import Recorder from 'recorder-core'
import 'recorder-core/src/engine/mp3.js'
import 'recorder-core/src/engine/mp3-engine.js'
import 'recorder-core/src/extensions/buffer_stream.player.js'

/** 引入RecordApp **/
import RecordApp from 'recorder-core/src/app-support/app.js'
// 【所有平台必须引入】uni-app支持文件

import './app-uni-support.js'
//引入阿里云语音识别插件
import 'recorder-core/src/extensions/asr.aliyun.short.js'
// 通信方法
import {
	makeUniMsgSender
} from './h5UniMsgHandlers.js'


let SendInterval = 500
let realTimeSendTryTime = 0
let realTimeSendTryBytesChunks
let realTimeSendTryClearPrevBufferIdx


//重置环境，每次开始录音时必须先调用此方法，清理环境
const RealTimeSendTryReset = function() {
	realTimeSendTryTime = 0
}

//=====实时处理时清理一下内存（延迟清理），本方法先于RealTimeSendTry执行======
const RealTimeOnProcessClear = function(buffers, newBufferIdx) {
	if (realTimeSendTryTime == 0) {
		realTimeSendTryTime = Date.now()
		realTimeSendTryBytesChunks = []
		realTimeSendTryClearPrevBufferIdx = 0
	}

	//清理PCM缓冲数据，最后完成录音时不能调用stop，因为数据已经被清掉了
	//这里进行了延迟操作（必须要的操作），只清理上次到现在的buffer
	for (var i = realTimeSendTryClearPrevBufferIdx; i < newBufferIdx; i++) {
		buffers[i] = null
	}
	realTimeSendTryClearPrevBufferIdx = newBufferIdx
}

const RealTimeSendTry = function(chunkBytes, isClose) {
	if (chunkBytes) {
		//推入缓冲再说
		realTimeSendTryBytesChunks.push(chunkBytes)
	}

	var t1 = Date.now()
	if (!isClose && t1 - realTimeSendTryTime < SendInterval) {
		return //控制缓冲达到指定间隔才进行传输
	}
	realTimeSendTryTime = t1

	//mp3缓冲的chunk拼接成一个更长点的mp3
	var len = 0
	for (var i = 0; i < realTimeSendTryBytesChunks.length; i++) {
		len += realTimeSendTryBytesChunks[i].length
	}
	var chunkData = new Uint8Array(len)
	for (var i = 0, idx = 0; i < realTimeSendTryBytesChunks.length; i++) {
		var chunk = realTimeSendTryBytesChunks[i]
		chunkData.set(chunk, idx)
		idx += chunk.length
	}
	realTimeSendTryBytesChunks = []

	var arrayBuffer = chunkData.buffer


}

const currentKeyTag = function() {
	if (!RecordApp.Current) return '[?]'
	// #ifdef APP
	var tag2 = 'Renderjs+H5'
	if (RecordApp.UniNativeUtsPlugin) {
		tag2 = RecordApp.UniNativeUtsPlugin.nativePlugin ?
			'NativePlugin' :
			'UtsPlugin'
	}
	return RecordApp.Current.Key + '(' + tag2 + ')'
	// #endif
	return RecordApp.Current.Key
}

const formatTime = function(ms, showSS) {
	var ss = ms % 1000
	ms = (ms - ss) / 1000
	var s = ms % 60
	ms = (ms - s) / 60
	var m = ms % 60
	ms = (ms - m) / 60
	var h = ms,
		v = ''
	if (h > 0) v += (h < 10 ? '0' : '') + h + ':'
	v += (m < 10 ? '0' : '') + m + ':'
	v += (s < 10 ? '0' : '') + s
	if (showSS) v += '″' + ('00' + ss).substr(-3)
	return v
}

/**实现apiRequest接口，tokenApi的请求实现方法**/
var uni_ApiRequest = function(url, args, success, fail) {
	console.error(args.lang)
	success({
		appkey: args.lang == '日语' ? 'ujOr2QnBmkimUAaS' : "OudgILuHvUpIdOFf",
		token: url
	});
};
/**实现compatibleWebSocket接口**/
var uni_WebSocket = function(url) {
	//事件回调
	var ws = {
		onopen: () => {},
		onerror: (event) => {},
		onclose: (event) => {},
		onmessage: (event) => {}
	};
	var store = ws.storeData = {};

	//发送数据，data为字符串或者arraybuffer
	ws.send = (data) => {
		if (store.webSocket && store.webSocket.readyState === WebSocket.OPEN) {
			store.webSocket.send(data);
		}
	};
	//进行连接
	ws.connect = () => {
		try {
			var webSocket = store.webSocket = new WebSocket(url);

			webSocket.onopen = () => {
				if (store.isOpen) return;
				store.isOpen = 1;
				ws.onopen();
			};

			webSocket.onclose = (e) => {
				if (store.isClose) return;
				store.isClose = 1;
				ws.onclose({
					code: e.code || -1,
					reason: e.reason || ""
				});
			};

			webSocket.onerror = (e) => {
				if (store.isError) return;
				store.isError = 1;
				ws.onerror({
					message: e.message || "WebSocket连接错误"
				});
			};

			webSocket.onmessage = (e) => {
				ws.onmessage({
					data: e.data
				});
			};
		} catch (error) {
			if (store.isError) return;
			store.isError = 1;
			ws.onerror({
				message: "创建WebSocket连接出现错误：" + error.message
			});
		}
	};
	//关闭连接
	ws.close = (code, reason) => {
		if (store.webSocket) {
			store.webSocket.close(code, reason);
		}
	};
	return ws;
};

export default {
	//开始录音
	recStart__2() {
		console.log(currentKeyTag() + " 正在打开录音...");
		RecordApp.UniWebViewActivate(this); //App环境下必须先切换成当前页面WebView
		RecordApp.Start({
			type: this.recType,
			sampleRate: this.recSampleRate,
			bitRate: this.recBitRate,

			onProcess: (buffers, powerLevel, duration, sampleRate, newBufferIdx, asyncEnd) => {

				if (this.asr) { //已打开实时语音识别
					this.asr.input(buffers, sampleRate, newBufferIdx);
				}
			}

		}, () => {

		}, (msg) => {
			console.log(currentKeyTag() + " 开始录音失败：" + msg, 1);
			// this.asrCancel("开始录音失败"); //立即结束语音识别
		});
	},
	//开始语音识别
	recStart__asrStart(asrTokenApi, lang) {

		RecordApp.UniWebViewActivate(this); //App环境下必须先切换成当前页面WebView
		//创建语音识别对象，每次识别都要新建，asr不能共用
		console.log('recStart__asrStart===》' + lang)
		var asr = this.asr = Recorder.ASR_Aliyun_Short({
			tokenApi: asrTokenApi,
			apiArgs: {
				lang: lang || '普通话'
			},
			apiRequest: uni_ApiRequest, //tokenApi的请求实现方法
			compatibleWebSocket: uni_WebSocket, //返回兼容WebSocket的对象
			asrProcess: (text, nextDuration, abortMsg) => {
				/***实时识别结果，必须返回true才能继续识别，否则立即超时停止识别***/
				if (abortMsg) {
					//语音识别中途出错
					console.log("[asrProcess回调]被终止：" + abortMsg);
					console.log("语音识别出错"); //立即结束录音，就算继续录音也不会识别
					return false;
				};
				this.asrTxt = text;
				// console.log('asrTxt===>', this.asrTxt)
				return nextDuration <= 2 * 60 * 1000; //允许识别2分钟的识别时长（比录音时长小5秒）
			},
			log: (msg, color) => {
				// console.log(msg, color == 1 ? "#faa" : "#aaa");
			}
		});
		console.log("语言：" + asr.set.apiArgs.lang + "，tokenApi：" + asr.set.tokenApi + "，正在打开语音识别...");
		//打开语音识别，建议先打开asr，成功后再开始录音
		asr.start(() => { //无需特殊处理start和stop的关系，只要调用了stop，会阻止未完成的start，不会执行回调
			console.log("已开始语音识别", 2);
			this.recStart__2();
		}, (errMsg) => {

			console.error("语音识别开始失败", errMsg, 1);
			// this.asrCancel("语音识别开始失败");
		});
	},


	//停止录音，结束语音识别
	asrCancel(cancelMsg) {
		console.log("正在停止...");
		const msgSender = makeUniMsgSender()
		var asr2 = this.asr;
		this.asr = null; //先干掉asr，防止重复stop
		if (!asr2) {
			console.log("未开始识别", 1);
		} else {
			//asr.stop 和 rec.stop 无需区分先后，同时执行就ok了
			asr2.stop((text, abortMsg) => {
				if (abortMsg) {
					abortMsg = "发现识别中途被终止(一般无需特别处理)：" + abortMsg;
				};
				console.log('最总返回===》', this.asrTxt);
				let obj_ = {
					text: this.asrTxt
				}
				msgSender.sendMessage('speechSound', obj_)

			}, (errMsg) => {

				console.error("语音识别" + (cancelMsg ? "被取消" : "结束失败") + "：" + errMsg, 1);
			});
		};

		RecordApp.Stop((aBuf, duration, mime) => {

		}, (msg) => {
			msgSender.sendMessage('recordFailed', 1)
			console.error("结束录音失败：" + msg, 1);
		});
	},
	recReq(json, flag) {
		if (json && json.time) {
			SendInterval = json.time
		}
		let jsonData = json
		RecordApp.UniNativeUtsPlugin = null
		const msgSender = makeUniMsgSender()

		if (RecordApp.UniIsApp() && !RecordApp.UniNativeUtsPlugin) {
			console.log(
				'当前是在App的renderjs中使用H5进行录音，iOS上只支持14.3以上版本，且iOS上每次进入页面后第一次请求录音权限时、或长时间无操作再请求录音权限时WebView均会弹出录音权限对话框，不同旧iOS版本（低于iOS17）下H5录音可能存在的问题在App中同样会存在；使用配套的原生录音插件或uts插件时无以上问题和版本限制，Android也无以上问题',
				'#f60'
			)
		}

		if (this.useAEC) {
			//这个是Start中的audioTrackSet配置，在h5（H5、App+renderjs）中必须提前配置，因为h5中RequestPermission会直接打开录音
			RecordApp.RequestPermission_H5OpenSet = {
				audioTrackSet: {
					noiseSuppression: true,
					echoCancellation: true,
					autoGainControl: true
				}
			}
		}

		console.log('正在请求录音权限...')
		RecordApp.UniWebViewActivate(this) //App环境下必须先切换成当前页面WebView
		RecordApp.RequestPermission(
			() => {

				if (flag == 'permissions') {
				
					msgSender.sendMessage('getmicpermissionscallback', 1)
				} else if (json) {
					this.recStart(json)
				}
			},
			(msg, isUserNotAllow) => {

		
				msgSender.sendMessage('getmicpermissionscallback', 0)
				console.log(
					currentKeyTag() +
					' ' +
					(isUserNotAllow ? 'isUserNotAllow,' : '') +
					'请求录音权限失败：' +
					msg,
					1
				)
			}
		)
	},

	recStart(json) {
		this.SeqId = 0
		this.IsEnd = 0

		RealTimeSendTryReset()
		clearTimeout(this.startTimer)

		this.takeoffEncodeChunkMsg = ''
		var takeEcCount = 0,
			takeEcSize = 0
		this.takeEcChunks = this.takeoffEncodeChunkSet ? [] : null

		// 消息发射器
		const msgSender = makeUniMsgSender()

		RecordApp.UniWebViewActivate(this) //App环境下必须先切换成当前页面WebView
		RecordApp.Start({
				type: this.recType,
				sampleRate: this.recSampleRate,
				bitRate: this.recBitRate,
				audioTrackSet: !this.useAEC ?
					null : {
						//配置回声消除，H5、App、小程序均可用，但并不一定会生效；注意：H5、App+renderjs中需要在请求录音权限前进行相同配置RecordApp.RequestPermission_H5OpenSet后此配置才会生效
						noiseSuppression: true,
						echoCancellation: true,
						autoGainControl: true
					},

				onProcess: (
					buffers,
					powerLevel,
					duration,
					sampleRate,
					newBufferIdx,
					asyncEnd
				) => {
					//全平台通用：可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考Recorder文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等

					//注意：App里面是在renderjs中进行实际的音频格式编码操作，此处的buffers数据是renderjs实时转发过来的，修改此处的buffers数据不会改变renderjs中buffers，所以不会改变生成的音频文件，可在onProcess_renderjs中进行修改操作就没有此问题了；如需清理buffers内存，此处和onProcess_renderjs中均需要进行清理，H5、小程序中无此限制
					//注意：如果你要用只支持在浏览器中使用的Recorder扩展插件，App里面请在renderjs中引入此扩展插件，然后在onProcess_renderjs中调用这个插件；H5可直接在这里进行调用，小程序不支持这类插件；如果调用插件的逻辑比较复杂，建议封装成js文件，这样逻辑层、renderjs中直接import，不需要重复编写
					RealTimeOnProcessClear(buffers, newBufferIdx)


				},
				onProcess_renderjs: function(
					buffers,
					powerLevel,
					duration,
					sampleRate,
					newBufferIdx,
					asyncEnd
				) {
					//App中在这里修改buffers才会改变生成的音频文件
					//App中是在renderjs中进行的可视化图形绘制，因此需要写在这里，this是renderjs模块的this（也可以用This变量）；如果代码比较复杂，请直接在renderjs的methods里面放个方法xxxFunc，这里直接使用this.xxxFunc(args)进行调用
					// var wave=this.waveStore&&this.waveStore[this.recwaveChoiceKey];
					// if(wave){
					// 	wave.input(buffers[buffers.length-1],powerLevel,sampleRate);
					// }
				},

				takeoffEncodeChunk: !this.takeoffEncodeChunkSet ?
					null : (chunkBytes) => {
						//全平台通用：实时接收到编码器编码出来的音频片段数据，chunkBytes是Uint8Array二进制数据，可以实时上传（发送）出去
						//App中如果未配置RecordApp.UniWithoutAppRenderjs时，建议提供此回调，因为录音结束后会将整个录音文件从renderjs传回逻辑层，由于uni-app的逻辑层和renderjs层数据交互性能实在太拉跨了，大点的文件传输会比较慢，提供此回调后可避免Stop时产生超大数据回传
						RealTimeSendTry(chunkBytes, false)

						takeEcCount++
						takeEcSize += chunkBytes.byteLength
						this.takeoffEncodeChunkMsg =
							'已接收到' + takeEcCount + '块，共' + takeEcSize + '字节'
						// console.error('已接收到' + takeEcCount + '块，共' + takeEcSize + '字节')
						this.takeEcChunks.push(chunkBytes)
					},
				takeoffEncodeChunk_renderjs: !this.takeoffEncodeChunkSet ?
					null : `function(chunkBytes){
                //App中这里可以做一些仅在renderjs中才生效的事情，不提供也行，this是renderjs模块的this（也可以用This变量）
            }`,

				start_renderjs: `function(){
                //App中可以放一个函数，在Start成功时renderjs中会先调用这里的代码，this是renderjs模块的this（也可以用This变量）
                //放一些仅在renderjs中才生效的事情，比如初始化，不提供也行
            }`,
				stop_renderjs: `function(aBuf,duration,mime){
                //App中可以放一个函数，在Stop成功时renderjs中会先调用这里的代码，this是renderjs模块的this（也可以用This变量）
                this.audioData=aBuf; //留着给Stop时进行转码成wav播放
            }`
			},
			() => {

				// console.log(this.currentKeyTag()+" 录制中："+this.recType
				// 	+" "+this.recSampleRate+" "+this.recBitRate+"kbps"
				// 	+(this.takeoffEncodeChunkSet?" takeoffEncodeChunk":"")
				// 	+(this.useAEC?" useAEC":"")
				// 	+(this.appUseH5Rec?" appUseH5Rec":""),2);
				//创建音频可视化图形绘制
				// this.initWaveStore();
			},
			(msg) => {
				console.log(currentKeyTag() + ' 开始录音失败：' + msg, 1)
			}
		)
	},

	recStop(json) {
		console.log('正在结束录音...')
		const msgSender = makeUniMsgSender()

		RecordApp.Stop(
			(aBuf, duration, mime) => {
				//全平台通用：aBuf是ArrayBuffer音频文件二进制数据，可以保存成文件或者发送给服务器
				//App中如果在Start参数中提供了stop_renderjs，renderjs中的函数会比这个函数先执行
				this.IsEnd = 1
				clearTimeout(this.startTimer)
				RealTimeSendTry(null, true)
				if (this.takeEcChunks) {
					// aBuf_renderjs=""; //renderjs的数据是空的
					// console.log("启用takeoffEncodeChunk后Stop返回的blob长度为0不提供音频数据");
					var len = 0
					for (var i = 0; i < this.takeEcChunks.length; i++)
						len += this.takeEcChunks[i].length
					var chunkData2 = new Uint8Array(len)
					for (var i = 0, idx = 0; i < this.takeEcChunks.length; i++) {
						var itm = this.takeEcChunks[i]
						chunkData2.set(itm, idx)
						idx += itm.length
					}
					aBuf = chunkData2.buffer

				}

				this.lastRecBuffer = aBuf

			},
			(msg) => {
				console.log('结束录音失败：' + msg, 1)
			}
		)
	}
}


// WEBPACK FOOTER //
// ./utils/h5Recorder.js